module.exports = __webpack_public_path__ + "img/step2.eed6edb2.svg";